import { STRING } from '@/plugins/sdk/fields'
import isString from 'lodash/isString'

export default {
  label: 'Does not end in',
  operator: 'does not end in',
  fields: [ STRING ],
  isValidValue (value) {
    return isString(value) && value.length
  }
}
